import RunConfigService from './runConfigService.js';
import axios from 'axios';

/**
 *
 * BrowserDetection object is immediately executed when the page loads.
 * This Object is used to detect the browser and version the user is using.
 *
 * @namespace MarketSiteRegionsV2
 */

export default {
    getMarketSiteRegionData,
    getMarketSiteRegionByCountry
}

/**
 * returns all region and market data based in AEM
 * @returns Promise<data>
 */
async function getMarketSiteRegionData() {
    let REGIONS_SERVICE_URL = RunConfigService.getBaseUrl() + "/apps/hello/services/regions/v2.json";
    //TEST
    // let env = RunConfigService.getEnvironmentCode().toUpperCase();
    // let REGIONS_SERVICE_URL = '//' + RunConfigService[env] + "/apps/hello/services/regions/v2.json";
    //TEST
    let regionData = await axios.request({
        method: 'get',
        url: REGIONS_SERVICE_URL,
        responseType: 'json'
    });

    return regionData.data;
}

/**
 * Returns the region a particular market belongs too
 * @param country
 * @return String<region>
 */
async function getMarketSiteRegionByCountry (country) {
    let marketData = await getMarketSiteRegionData();
    let regionName = "unknown";
    for(let i = 0; i < marketData.length;i++) {
        if(!!marketData[i].countryname) {
            for(let j = 0; j < marketData[i].countryname.length; j++) {
                if(marketData[i].countryname[j].countryCode === country) {
                    regionName = marketData[i].regionname;
                }
            }
        }

    }
    return regionName;
}
